/** Suppléments visibles avant le lien « Voir les X autres options » (fiche du site, tunnel, carte cadeau). */
export const SUPPLEMENTS_VISIBLE_COUNT = 4;

/**
 * Jusqu'à 4 suppléments, tous visibles ; au-delà, les 4 premiers tant que la liste n'est pas dépliée. Un
 * supplément déjà coché reste toujours visible : un choix restauré ne se cache pas derrière le lien.
 */
export function splitVisibleSupplements<T extends { selected: boolean }>(
  supplements: readonly T[],
  expanded: boolean,
): { visible: T[]; hiddenCount: number } {
  if (expanded || supplements.length <= SUPPLEMENTS_VISIBLE_COUNT) return { visible: [...supplements], hiddenCount: 0 };
  const visible = supplements.filter(
    (supplement, index): boolean => index < SUPPLEMENTS_VISIBLE_COUNT || supplement.selected,
  );
  return { visible, hiddenCount: supplements.length - visible.length };
}

/** Libellé du lien : « Voir l’autre option » / « Voir les 3 autres options ». */
export const supplementsShowMoreLabel = (hiddenCount: number, labels: { one: string; other: string }): string =>
  hiddenCount === 1 ? labels.one : labels.other.replace('{count}', String(hiddenCount));
